var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { container } from 'tsyringe';
import { Authenticator } from 'packages/authentication/services/Authenticator';
import UnauthenticatedPageNotFound from 'ui/v1/UnauthenticatedPageNotFound.vue';
import store from 'store/core';
import AppWrapper from '@/app/views/AppWrapper.vue';
import { types } from 'store/core/mutations';
import NotificationsApp from '@/app/views/notifications/NotificationsApp.vue';
import HistoryView from '@/app/views/notifications/HistoryView.vue';
import SettingsView from '@/app/views/notifications/SettingsView.vue';
import MobileView from '@/app/views/mobile/MobileView.vue';
import PageNotFound from 'ui/v1/PageNotFound.vue';
import NotAuthorized from 'ui/v1/NotAuthorized.vue';
import EmailRedirect from 'ui/v1/EmailRedirect.vue';
import { dashboardTalentCardRoutes, trmTalentCardRoutes, } from './talent-card';
import NavigationService from 'services/NavigationService';
import ENV from 'config/env';
import posthog from 'posthog-js';
import { campaignRequestRoutes } from '@/app/routes/campaign-request';
import { jobRoutes } from './job';
// eslint-disable-next-line spaced-comment
//#region lazy imports
var UnsubscribeRecruitmentEmailView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/candidates/UnsubscribeRecruitmentEmailView.vue'); };
var UnsubscribeRecruitmentEmailSuccessView = function () { return import(/* webpackChunkName: "job-core-views" */ '@/app/views/candidates/UnsubscribeRecruitmentEmailSuccessView.vue'); };
var JobListNewView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/NewView.vue'); };
var JobListView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/JobListView.vue'); };
var JobListNavigationView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/NavigationView.vue'); };
var JobListSharingView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/SharingView.vue'); };
var JobListDomainView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/DomainView.vue'); };
var JobListSettingsView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/SettingsView.vue'); };
var JobListDesignView = function () { return import(/* webpackChunkName: "job-list-views" */ '@/app/views/job_lists/DesignView.vue'); };
var ProfileView = function () { return import(/* webpackChunkName: "profile-views" */ '@/app/views/profile/ProfileView.vue'); };
var OverviewView = function () { return import(/* webpackChunkName: "profile-views" */ '@/app/views/profile/OverviewView.vue'); };
var SecurityView = function () { return import(/* webpackChunkName: "profile-views" */ '@/app/views/profile/SecurityView.vue'); };
var SettingsApp = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/SettingsApp.vue'); };
var EmailTemplatesView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/EmailTemplatesView.vue'); };
var CreateEditEmailTemplateView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/CreateEditEmailTemplateView.vue'); };
var DefaultsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/DefaultsView.vue'); };
var FormTemplatesView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/FormTemplatesView.vue'); };
var SettingsFormTemplateEditorView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/SettingsFormTemplateEditorView.vue'); };
var BrandingSettingsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/BrandingSettingsView.vue'); };
var UsersView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/UsersView.vue'); };
var TeamSettingsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/TeamSettingsView.vue'); };
var TeamManagementView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/TeamManagementView.vue'); };
var TagSettingsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/TagSettingsView.vue'); };
var AttributeManagerView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/AttributeManagerView.vue'); };
var ExportIntegrationsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/ExportIntegrationsView.vue'); };
var TePalvelutView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/TePalvelutView.vue'); };
var LegalSettingsView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/LegalSettingsView.vue'); };
var ContactAndAddressView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/ContactAndAddressView.vue'); };
var FeaturesView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/FeaturesView.vue'); };
var PrivacyCenterView = function () { return import(/* webpackChunkName: "settings-views" */ '@/app/views/settings/PrivacyCenterView.vue'); };
var TalentsView = function () { return import(/* webpackChunkName: "candidate-pool-views" */ '@/app/views/candidate_pool/views/TalentsView.vue'); };
var TalentFileViewer = function () { return import(/* webpackChunkName: "candidate-pool-views" */ '@/app/views/candidate_pool/views/TalentFileViewer.vue'); };
var CandidatePoolTalentView = function () { return import(/* webpackChunkName: "candidate-pool-views" */ '@/app/views/candidate_pool/views/TalentView.vue'); };
var SetupView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/SetupView.vue'); };
var SetPasswordView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/SetPasswordView.vue'); };
var TermsView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/TermsView.vue'); };
var SetupWelcomeView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/SetupWelcomeView.vue'); };
var SetupFinalizationView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/SetupFinalizationView.vue'); };
var SetupJobListView = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/SetupJobListView.vue'); };
var SetPasswordViewTexts = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/setup_view_components/SetPasswordViewTexts.vue'); };
var TermsViewTexts = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/setup_view_components/TermsViewTexts.vue'); };
var SetupJobListTexts = function () { return import(/* webpackChunkName: "setup-views" */ '@/app/views/setup/setup_view_components/SetupJobListTexts.vue'); };
var DashboardView = function () { return import(/* webpackChunkName: "dashboard-views" */ '@/app/views/dashboard/DashboardView.vue'); };
var DashboardTalentView = function () { return import(/* webpackChunkName: "dashboard-views" */ '@/app/views/dashboard/DashboardTalentView.vue'); };
var InventoryView = function () { return import(/* webpackChunkName: "dashboard-views" */ '@/app/views/inventory/InventoryView.vue'); };
var AuditLog = function () { return import(/* webpackChunkName: "dashboard-views" */ '@/app/views/inventory/AuditLog.vue'); };
var AnalyticsOverviewView = function () { return import(/* webpackChunkName: "analytics-views" */ '@/app/views/analytics/OverviewView.vue'); };
// mobile talent viewer
var MobileFormResponses = function () { return import(/* webpackChunkName: "mobile-talent-views" */ '@/app/views/mobile/FormView.vue'); };
var MobileTalentViewer = function () { return import(/* webpackChunkName: "mobile-talent-views" */ '@/app/views/mobile/TalentViewer.vue'); };
var MobileThreadListView = function () { return import(/* webpackChunkName: "mobile-talent-views" */ '@/app/views/mobile/ThreadListView.vue'); };
var MobileThreadReaderView = function () { return import(/* webpackChunkName: "mobile-talent-views" */ '@/app/views/mobile/ThreadReaderView.vue'); };
var MobileFilesView = function () { return import(/* webpackChunkName: "mobile-talent-views" */ '@/app/views/mobile/FilesView.vue'); };
// eslint-disable-next-line spaced-comment
//#endregion
export default (function (app) {
    var navigationService = container.resolve(NavigationService);
    return [
        {
            path: '/auth/login',
            beforeEnter: function () {
                // Track legacy login page visits to determine the safety of removing it
                posthog.capture('Legacy login page visited');
                var searchParams = new URL(window.location.href).searchParams;
                var redirectUrl = new URL(ENV.LOGIN_URL);
                if (searchParams.has('redirectUrl')) {
                    redirectUrl.searchParams.set('redirect', searchParams.get('redirectUrl'));
                }
                window.location.replace(redirectUrl.toString());
            },
        },
        {
            path: '/not-found',
            component: UnauthenticatedPageNotFound,
            name: 'Public.404',
        },
        {
            path: '/unsubscribe',
            component: UnsubscribeRecruitmentEmailView,
            name: 'Public.Unsubscribe',
            props: function (route) {
                var _a, _b, _c, _d, _e, _f;
                return ({
                    email: (_a = route.query) === null || _a === void 0 ? void 0 : _a.email,
                    jobId: (_b = route.query) === null || _b === void 0 ? void 0 : _b.jobId,
                    formResponseUuid: (_c = route.query) === null || _c === void 0 ? void 0 : _c.validation,
                    createdAt: (_d = route.query) === null || _d === void 0 ? void 0 : _d.code,
                    companyId: (_e = route.query) === null || _e === void 0 ? void 0 : _e.companyId,
                    formTitle: (_f = route.query) === null || _f === void 0 ? void 0 : _f.formTitle,
                });
            },
        },
        {
            path: '/unsubscribe/result',
            component: UnsubscribeRecruitmentEmailSuccessView,
            name: 'Public.Unsubscribe.Result',
        },
        {
            path: '/email-redirect',
            component: EmailRedirect,
            name: 'Public.Email',
            props: function (route) {
                var _a, _b, _c, _d, _e;
                return ({
                    domain: (_a = route.query) === null || _a === void 0 ? void 0 : _a.jobilla_domain,
                    actorId: (_b = route.query) === null || _b === void 0 ? void 0 : _b.jobilla_actor_id,
                    emitterId: (_c = route.query) === null || _c === void 0 ? void 0 : _c.jobilla_emitter_id,
                    emitterType: (_d = route.query) === null || _d === void 0 ? void 0 : _d.jobilla_emitter_type,
                    eventId: (_e = route.query) === null || _e === void 0 ? void 0 : _e.jobilla_event_id,
                });
            },
        },
        {
            path: '/welcome/:token/:lang',
            component: SetupWelcomeView,
            name: 'Setup.User.Welcome',
            props: function (route) { return ({
                userToken: route.params.token,
                lang: route.params.lang,
            }); },
        },
        {
            path: '/welcome/:token/:lang',
            component: SetupView,
            redirect: { name: 'Setup.Password' },
            name: 'Setup.User',
            children: [
                {
                    path: '1',
                    components: {
                        default: SetPasswordView,
                        texts: SetPasswordViewTexts,
                    },
                    name: 'Setup.User.Password',
                },
                {
                    path: '2',
                    components: {
                        default: TermsView,
                        texts: TermsViewTexts,
                    },
                    name: 'Setup.User.Terms',
                    props: {
                        default: function (route) { return ({ token: route.params.token }); },
                    },
                },
            ],
        },
        {
            path: '/welcome/:token/3',
            component: SetupFinalizationView,
            name: 'Setup.User.Complete',
        },
        {
            path: '/setup/:token/:lang',
            component: SetupWelcomeView,
            name: 'Setup.Welcome',
            props: function (route) { return ({
                userToken: route.params.token,
                lang: route.params.lang,
                isCompanyAdmin: true,
            }); },
        },
        {
            path: '/setup/:token/:lang',
            name: 'Setup',
            component: SetupView,
            props: function (route) { return ({ isCompanyAdmin: true, inviteToken: route.params.token }); },
            redirect: { name: 'Setup.Password' },
            children: [
                {
                    path: '1',
                    components: {
                        default: SetPasswordView,
                        texts: SetPasswordViewTexts,
                    },
                    name: 'Setup.Password',
                    props: {
                        default: { isCompanyAdmin: true },
                    },
                },
                {
                    path: '2',
                    components: {
                        default: TermsView,
                        texts: TermsViewTexts,
                    },
                    name: 'Setup.Terms',
                    props: {
                        default: { isCompanyAdmin: true },
                    },
                },
                {
                    path: '3',
                    components: {
                        default: SetupJobListView,
                        texts: SetupJobListTexts,
                    },
                    name: 'Setup.JobList',
                    props: {
                        default: function (route) { return ({ token: route.params.token }); },
                    },
                },
            ],
        },
        {
            path: '/setup/:token/4',
            component: SetupFinalizationView,
            name: 'Setup.Complete',
        },
        {
            path: '/',
            component: AppWrapper,
            beforeEnter: (function (to, from, next) {
                var routeHasAuthParams = to.query['access-token'] || to.query.company_id;
                if (routeHasAuthParams) {
                    var query = navigationService.stripAuthFromRoute(to).query;
                    return next(__assign(__assign({}, to), { query: query }));
                }
                return next();
            }),
            children: [
                {
                    path: '/not-found',
                    component: PageNotFound,
                    name: 'Error.404',
                },
                {
                    path: '/not-authorized',
                    component: NotAuthorized,
                    name: 'Error.403',
                },
            ],
        },
        {
            path: '/c/:companyId',
            component: AppWrapper,
            beforeEnter: function (to, from, next) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, navigationService.authorizeRouteGuard(+(((_a = to.params) === null || _a === void 0 ? void 0 : _a.companyId) || app.currentCompanyId), to, next)];
                        case 1:
                            _b.sent();
                            return [2 /*return*/, next()];
                    }
                });
            }); },
            props: function (route) { return ({
                companyId: parseInt(route.params.companyId),
            }); },
            children: __spreadArray(__spreadArray([
                {
                    path: 'profile',
                    component: ProfileView,
                    redirect: { name: 'Profile.Overview' },
                    children: [
                        {
                            path: 'overview',
                            name: 'Profile.Overview',
                            component: OverviewView,
                        },
                        {
                            path: 'security',
                            name: 'Profile.Security',
                            component: SecurityView,
                        },
                    ],
                },
                {
                    path: 'notifications',
                    component: NotificationsApp,
                    children: [
                        {
                            path: '',
                            redirect: { name: 'Notifications.History' },
                        },
                        {
                            path: 'history',
                            component: HistoryView,
                            name: 'Notifications.History',
                        },
                        {
                            path: 'settings',
                            component: SettingsView,
                            name: 'Notifications.Settings',
                        },
                    ],
                },
                {
                    path: 'inventory',
                    component: InventoryView,
                    name: 'Inventory',
                },
                {
                    path: 'audit-log',
                    component: AuditLog,
                    name: 'AuditLog',
                }
            ], campaignRequestRoutes), [
                {
                    path: '/',
                    name: 'Dashboard',
                    component: DashboardView,
                    children: [
                        {
                            path: 'candidate/:jobId/:candidateId',
                            name: 'Dashboard.TalentView',
                            component: DashboardTalentView,
                            props: function (route) { return ({
                                candidateId: parseInt(route.params.candidateId),
                                jobId: parseInt(route.params.jobId),
                            }); },
                            redirect: { name: 'Dashboard.TalentCard.Forms' },
                            children: dashboardTalentCardRoutes,
                        },
                    ],
                },
                jobRoutes,
                {
                    path: 'settings',
                    beforeEnter: function (to, from, next) {
                        store.commit(types.SET_MODULE, 'settings');
                        store.dispatch('jobLists/listForCompany');
                        next();
                    },
                    redirect: {
                        name: 'Settings.Users.Teams',
                    },
                    name: 'Settings',
                    component: SettingsApp,
                    children: [
                        {
                            path: 'email/templates',
                            name: 'Settings.Email.Templates',
                            component: EmailTemplatesView,
                        },
                        {
                            path: 'email/templates/:groupId/new',
                            name: 'Settings.Email.NewTemplate',
                            component: CreateEditEmailTemplateView,
                            props: function (route) { return ({
                                groupId: parseInt(route.params.groupId),
                                groupName: route.query.groupName,
                            }); },
                        },
                        {
                            path: 'email/templates/:groupId/edit/:templateId',
                            name: 'Settings.Email.EditTemplate',
                            component: CreateEditEmailTemplateView,
                            props: function (route) { return ({
                                groupId: parseInt(route.params.groupId),
                                templateId: parseInt(route.params.templateId),
                            }); },
                        },
                        {
                            path: 'email/defaults',
                            name: 'Settings.Email.Defaults',
                            component: DefaultsView,
                        },
                        {
                            path: 'forms/templates',
                            name: 'Settings.Forms.Templates',
                            component: FormTemplatesView,
                        },
                        {
                            path: 'forms/templates/:templateId',
                            name: 'Settings.Forms.Edit',
                            component: SettingsFormTemplateEditorView,
                        },
                        {
                            path: 'content/branding',
                            name: 'Settings.Content.Branding',
                            component: BrandingSettingsView,
                        },
                        {
                            path: 'job-lists',
                            name: 'Settings.JobLists',
                            redirect: { name: 'Settings.JobLists.New' },
                            component: JobListView,
                            children: [
                                {
                                    path: 'new',
                                    name: 'Settings.JobLists.New',
                                    component: JobListNewView,
                                },
                                {
                                    path: ':jobListId',
                                    component: { render: function (h) { return h('router-view'); } },
                                    name: 'JobLists.JobList',
                                    redirect: { name: 'JobLists.Navigation' },
                                    children: [
                                        {
                                            path: 'navigation',
                                            name: 'JobLists.Navigation',
                                            component: JobListNavigationView,
                                        },
                                        {
                                            path: 'design',
                                            name: 'JobLists.Design',
                                            component: JobListDesignView,
                                        },
                                        {
                                            path: 'sharing',
                                            name: 'JobLists.Sharing',
                                            component: JobListSharingView,
                                        },
                                        {
                                            path: 'domain',
                                            name: 'JobLists.Domain',
                                            component: JobListDomainView,
                                        },
                                        {
                                            path: 'settings',
                                            name: 'JobLists.Settings',
                                            component: JobListSettingsView,
                                        },
                                    ],
                                },
                            ],
                        },
                        {
                            path: 'users/users',
                            name: 'Settings.Users.Users',
                            component: UsersView,
                        },
                        {
                            path: 'users/teams',
                            name: 'Settings.Users.Teams',
                            component: TeamSettingsView,
                        },
                        {
                            path: 'users/team-management/:group_id',
                            redirect: { name: 'Settings.Users.TeamManagement' },
                        },
                        {
                            path: 'users/teams/:group_id',
                            name: 'Settings.Users.TeamManagement',
                            component: TeamManagementView,
                            props: true,
                        },
                        {
                            path: 'talents/tags',
                            name: 'Settings.Talents.Tags',
                            component: TagSettingsView,
                        },
                        {
                            path: 'talents/attributes',
                            name: 'Settings.Talents.Attributes',
                            component: AttributeManagerView,
                        },
                        {
                            path: 'talents/export-integrations',
                            name: 'Settings.Talents.ExportIntegrations',
                            component: ExportIntegrationsView,
                        },
                        {
                            path: 'company/legal',
                            name: 'Settings.Company.Legal',
                            component: LegalSettingsView,
                        },
                        {
                            path: 'company/contact-and-address',
                            name: 'Settings.Company.ContactAndAddress',
                            component: ContactAndAddressView,
                        },
                        {
                            path: 'administration',
                            redirect: 'Settings.Admin.GermanPortals',
                            component: { render: function (h) { return h('router-view'); } },
                            children: [
                                {
                                    path: 'features',
                                    name: 'Settings.Admin.Features',
                                    component: FeaturesView,
                                    beforeEnter: function (to, from, next) {
                                        if (!container.resolve(Authenticator).decodedToken.system_administrator) {
                                            return next(from);
                                        }
                                        next();
                                    },
                                },
                                {
                                    path: 'te-palvelut',
                                    name: 'Settings.Admin.TePalvelut',
                                    component: TePalvelutView,
                                    beforeEnter: function (to, from, next) {
                                        if (!container.resolve(Authenticator).decodedToken.system_administrator) {
                                            return next(from);
                                        }
                                        next();
                                    },
                                },
                                {
                                    path: 'privacy-center',
                                    name: 'Settings.Admin.PrivacyCenter',
                                    component: PrivacyCenterView,
                                },
                            ],
                        },
                    ],
                },
                {
                    path: 'candidates',
                    name: 'TalentsView',
                    component: TalentsView,
                    beforeEnter: function (to, from, next) {
                        store.commit(types.SET_MODULE, 'candidatePool');
                        next();
                    },
                    props: function (route) {
                        var _a, _b, _c, _d, _e, _f;
                        var tags = (_a = route === null || route === void 0 ? void 0 : route.query) === null || _a === void 0 ? void 0 : _a.tags;
                        return {
                            search: (_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.search,
                            tags: (tags && !Array.isArray(tags)) ? [tags] : tags,
                            sortField: (_c = route === null || route === void 0 ? void 0 : route.query) === null || _c === void 0 ? void 0 : _c.sortField,
                            sortDirection: (_d = route === null || route === void 0 ? void 0 : route.query) === null || _d === void 0 ? void 0 : _d.sortDirection,
                            page: parseInt((_f = (_e = route === null || route === void 0 ? void 0 : route.query) === null || _e === void 0 ? void 0 : _e.page) !== null && _f !== void 0 ? _f : 1),
                        };
                    },
                    children: [
                        {
                            path: ':candidateId',
                            name: 'TalentView',
                            component: CandidatePoolTalentView,
                            redirect: { name: 'CandidatePool.TalentCard.Forms' },
                            children: trmTalentCardRoutes,
                        },
                    ],
                },
                {
                    path: 'file-viewer/:candidateId/file/:file',
                    name: 'FullscreenFileViewer',
                    component: TalentFileViewer,
                },
                {
                    path: 'analytics',
                    beforeEnter: function (to, from, next) {
                        store.commit(types.SET_MODULE, 'analytics');
                        next();
                    },
                    component: AnalyticsOverviewView,
                    name: 'Analytics.Overview',
                },
                {
                    path: 'mobile',
                    component: MobileView,
                    name: 'Mobile',
                    redirect: { name: 'MobileView.TalentViewer.Index' },
                    children: [
                        {
                            path: 'jobs/:jobId/pipeline/:talentId/',
                            component: MobileTalentViewer,
                            name: 'MobileView.TalentViewer.Index',
                            props: function (route) {
                                var _a, _b, _c, _d;
                                return ({
                                    talentId: parseInt((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.talentId),
                                    jobId: parseInt((_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.jobId),
                                    domain: (_c = route.query) === null || _c === void 0 ? void 0 : _c.source,
                                    actorId: (_d = route.query) === null || _d === void 0 ? void 0 : _d.jobilla_actor_id,
                                });
                            },
                        },
                        {
                            path: 'jobs/:jobId/pipeline/:talentId/forms',
                            component: MobileFormResponses,
                            name: 'MobileView.TalentViewer.Forms',
                            props: function (route) {
                                var _a, _b;
                                return ({
                                    talentId: parseInt((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.talentId),
                                    jobId: parseInt((_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.jobId),
                                });
                            },
                        },
                        {
                            path: 'jobs/:jobId/pipeline/:talentId/threads',
                            component: MobileThreadListView,
                            name: 'MobileView.TalentViewer.Threads',
                            props: function (route) {
                                var _a, _b;
                                return ({
                                    talentId: parseInt((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.talentId),
                                    jobId: parseInt((_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.jobId),
                                });
                            },
                        },
                        {
                            path: 'jobs/:jobId/pipeline/:talentId/files',
                            component: MobileFilesView,
                            name: 'MobileView.TalentViewer.Files',
                            props: function (route) {
                                var _a, _b;
                                return ({
                                    talentId: parseInt((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.talentId),
                                    jobId: parseInt((_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.jobId),
                                });
                            },
                        },
                        {
                            path: 'jobs/:jobId/pipeline/:talentId/messages/:threadId',
                            component: MobileThreadReaderView,
                            name: 'MobileView.TalentViewer.Thread',
                            props: function (route) {
                                var _a, _b, _c;
                                return ({
                                    talentId: parseInt((_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.talentId),
                                    threadId: parseInt((_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.threadId),
                                    jobId: parseInt((_c = route === null || route === void 0 ? void 0 : route.params) === null || _c === void 0 ? void 0 : _c.jobId),
                                });
                            },
                        },
                    ],
                },
            ]),
        },
        // This route only exists so that we do not show Error.404 page before Company-in-URL
        // middleware can pick up the request and redirect to correct /c/... route.
        {
            path: '/',
            component: function () { return null; },
            name: 'Home',
        },
        {
            path: '*',
            component: PageNotFound,
            name: 'Error.CatchAll',
        },
    ];
});
